/**
 * Módulo del tutorial: La app en tu celular (PWA) (KAN-232).
 *
 * Instalar MiCampoDigital en la pantalla de inicio del celular (o en la
 * computadora) y usarla SIN SEÑAL: todo lo que cargás queda guardado en el
 * dispositivo y se sincroniza solo cuando vuelve la conexión.
 *
 * Sin anclas: es puro contenido — los pasos avanzan con "Siguiente".
 */

import type { TutorialModuleDef } from '../../../services/tutorial/types';

export const pwaModule: TutorialModuleDef = {
  id: 'pwa',
  title: 'La app en tu celular',
  description: 'Instalala en la pantalla de inicio y usala sin señal en el campo: todo queda guardado y se sincroniza solo al volver la conexión.',
  emoji: '📱',
  image: 'images/tutorial/pwa.png',
  permission: { module: 'tools', action: 'view' },
  grupo: 'equipo',
  route: '/dashboard',
  steps: [
    {
      id: 'concepto-pwa',
      route: '/tutorial',
      text: 'MiCampoDigital es una APP, no una página: la instalás en tu celular y queda como cualquier otra, con su ícono en la pantalla de inicio.',
      narration:
        'Un dato que muchos no saben: esto no es una página de internet más, es una aplicación de verdad. La instalás en tu celular, le queda el ícono en la pantalla de inicio como a cualquier app, y abre entera, sin andar buscando el navegador ni tipeando direcciones. Te muestro cómo.',
    },
    {
      id: 'instalar-celular',
      route: '/dashboard',
      text: 'En el celular: en iPhone (Safari) tocá Compartir □↑ → "Agregar a pantalla de inicio"; en Android (Chrome) tocá el menú ⋮ → "Instalar aplicación". Listo: ícono propio, abre a pantalla completa.',
      narration:
        'En el celular es un momento, y va según el teléfono. Si es un iPhone, con Safari: tocás el botón de compartir, el cuadradito con la flechita para arriba, y elegís Agregar a pantalla de inicio. Si es un Android, con Chrome: abrís el menú de los tres puntitos y elegís Instalar aplicación. En ambos casos le ponés el nombre que quieras, aceptás, y queda el ícono de Mi Campo Digital al lado de los demás. De ahí en adelante, se abre como cualquier app, a pantalla completa.',
    },
    {
      id: 'instalar-computadora',
      route: '/dashboard',
      text: 'En la computadora: el ícono de instalar que aparece en la barra de direcciones (o el menú ⋮ → "Instalar MiCampoDigital").',
      narration:
        'Y en la computadora también: en la barra de direcciones del navegador te va a aparecer un ícono de instalar, o lo encontrás en el menú de los tres puntitos. Un clic y la app queda instalada, con su ícono en el escritorio. Abre en su propia ventana, sin pestañas de por medio.',
    },
    {
      id: 'sin-senal',
      route: '/dashboard',
      text: 'La perla: SIN SEÑAL igual funciona. En el medio del campo cargás animales, lluvias, gastos — todo queda guardado en el dispositivo.',
      narration:
        'Y ahora la perla, pensada para el campo profundo: sin señal, la app funciona igual. En el medio del cuadro, donde no hay ni un palito de señal, cargás animales, anotás la lluvia, metés un gasto. Todo queda guardado en el aparato, seguro, esperando.',
    },
    {
      id: 'sync-solo',
      route: '/dashboard',
      target: '[data-ar-guide="header-sync-status"]',
      label: 'Indicador de Sync (arriba)',
      advanceOnClick: false,
      text: 'Al volver la conexión (o llegar a la casa con WiFi), todo se sincroniza SOLO — te avisamos qué quedó pendiente con el indicador de Sync.',
      narration:
        'Y cuando volvés a tener señal, o llegás a la casa donde hay wifi, todo eso se sincroniza solo: no hay que apretar ningún botón ni acordarse de nada. Arriba, el indicador de Sync te muestra si quedó algo pendiente de enviar. Vos trabajás tranquilo adonde nadie trabaja, y la app se las arregla con el resto.',
    },
  ],
  completionCheck: async () => false,
};
